import React from 'react'
import { useParams } from 'react-router-dom';
import { useGetClientQuestionnaireResponse } from '../../../hooks/professionals/useQuestionnaires';
import CustomLoading from '../../../components/Common/Loading';
import CommonLayout from '../../../layouts/Common';
import { getQuestionnaireResponseTitle } from '../../../helpers';
// import { Card, Space } from 'antd';
import { Container } from './style';
import { BehavioralAvoidanceInhibitionQuestionnaireResponse, ConditionsDuringPregnancyOfYourMotherQuestionnaireResponse, EmotionRegulationQuestionnaireResponse, ExpressivityResultResponse, FoodIntakeAndDigestionQuestionnaireResponse, MentalEmotionalFunctioningQuestionnaireResponse, NeurotransmittersQuestionnaireResponse, SocialSupportQuestionnaireResponse, StressIndicatorsQuestionnaireResponse } from './Response';

const QuestionnaireResponse = () => {
  const { id } = useParams();
  const {
    data: questionnaireResponse,
    loading: loadingQuestionnaireResponse,
    // refetch: refetchQuestionnaireResponse
  } = useGetClientQuestionnaireResponse(id as string);

  const renderQuestionnaireResult = () => {
    if (questionnaireResponse?.type) {
      switch (questionnaireResponse?.type) {
        case 'SocialSupportQuestionnaireResponse':
          return <SocialSupportQuestionnaireResponse questionnaireResponse={questionnaireResponse} />
        case 'BeqCcgResponse':
          return <ExpressivityResultResponse questionnaireResponse={questionnaireResponse} />
        case 'ErqCcgResponse':
          return <EmotionRegulationQuestionnaireResponse questionnaireResponse={questionnaireResponse} />
        case 'ConditionsOfMotherDuringPregnancyResponse':
          return <ConditionsDuringPregnancyOfYourMotherQuestionnaireResponse questionnaireResponse={questionnaireResponse} />
        case 'BisBasScaleResponse':
          return <BehavioralAvoidanceInhibitionQuestionnaireResponse questionnaireResponse={questionnaireResponse} />
        case 'MentalEmotionalFunctioningResponse':
          return <MentalEmotionalFunctioningQuestionnaireResponse questionnaireResponse={questionnaireResponse} />;
        case 'StressIndicatorsResponse':
          return <StressIndicatorsQuestionnaireResponse questionnaireResponse={questionnaireResponse} />;
        case 'NeurotransmittersResponse':
          return <NeurotransmittersQuestionnaireResponse questionnaireResponse={questionnaireResponse} />;
        case 'FoodIntakeAndDigestionResponse':
          return <FoodIntakeAndDigestionQuestionnaireResponse questionnaireResponse={questionnaireResponse} />;
        default:
      }
    }
  };

  if (loadingQuestionnaireResponse) {
    return <CustomLoading />
  }

  console.log('questionnaireResponse', questionnaireResponse)

  return (
    <CommonLayout title={getQuestionnaireResponseTitle(questionnaireResponse!.type)} width="70%">
      <Container>
        {renderQuestionnaireResult()}
      </Container>
    </CommonLayout>
  )
}

export default QuestionnaireResponse;